import React from 'react';

import { Container } from './styles';

import { Input } from '~/components/Form';

import {
 
  FormatarCodigoLiberacao,
 
} from '~/helpers';

const DetalheLibRemota = React.memo(props => {
  const { initials } = props;

   return (
    <Container>      
        <div className="Container__liberacao_cabecalho">
          Detalhe Liberação
          <Input
            name="txtposto"
            label="Posto"
            value={initials.poco_desc_abrev}
            disabled
          />

          <Input
            name="txtbico"
            label="Bico"
            value={initials.bico_numero}
            disabled
          />

          <Input
            name="txtplaca"
            label="Placa"
            value={initials.placa}
            disabled
          />
        </div>

        <div className="Container__liberacao">
          <Input
            name="codigo1"
            label="Código 01"
            value={FormatarCodigoLiberacao(initials.codigo1)}
            disabled
          />

          <Input
            name="codigo2"
            label="Código 02"
            value={FormatarCodigoLiberacao(initials.codigo2)}
            disabled
          />
        </div>
      
    </Container>
  );
}
);

export default DetalheLibRemota;